module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "page-selector"
  }, [_c('div', {
    staticClass: "form__wrapper"
  }, [_c('div', {
    staticClass: "form__section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['type'].empty),
      expression: "$v.$errors['type'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกประเภทการบริจาค")]), _vm._v(" "), _c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('label', {
    staticClass: "form__label form__label--title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "4")
    },
    on: {
      "change": function($event) {
        _vm.type = "4"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon _sl-tcfe"
  }, [_vm._v(" ")]), _vm._v("บริจาคทันที"), _c('br')])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form__section"
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('label', {
    staticClass: "form__label form__label--title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "3")
    },
    on: {
      "change": function($event) {
        _vm.type = "3"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon _sl-school"
  }, [_vm._v(" ")]), _vm._v("เลือกโรงเรียนที่ต้องการบริจาค\n        ")]), _vm._v(" "), (_vm.type == 3 && !_vm.selectedPage) ? _c('div', {
    staticClass: "form__sub-section"
  }, [_c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.province2),
      expression: "province2"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.province2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectProvince]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- จังหวัด -")]), _vm._v(" "), _vm._l((_vm.provinces), function(province) {
    return _c('option', {
      domProps: {
        "value": province.id
      }
    }, [_vm._v(_vm._s(province.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['province2'].empty),
      expression: "$v.$errors['province2'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกจังหวัด")]), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school),
      expression: "school"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.school = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectSchool]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- โรงเรียน -")]), _vm._v(" "), _vm._l((_vm.schools), function(school) {
    return _c('option', {
      domProps: {
        "value": school.id
      }
    }, [_vm._v(_vm._s(school.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['school'].empty),
      expression: "$v.$errors['school'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกโรงเรียน")])]) : _vm._e(), _vm._v(" "), (_vm.type == 3 && _vm.selectedPage) ? _c('div', {
    staticClass: "form__sub-section"
  }, [_c('div', {
    staticClass: "result-selected shadow"
  }, [_c('page-preview', {
    attrs: {
      "page": _vm.selectedPage
    },
    on: {
      "clear": _vm.clear
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form__section"
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('label', {
    staticClass: "form__label form__label--title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "2")
    },
    on: {
      "change": function($event) {
        _vm.type = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon _sl-province"
  }, [_vm._v(" ")]), _vm._v("เลือกจังหวัดที่ต้องการบริจาค\n        ")]), _vm._v(" "), (_vm.type == 2 && !_vm.selectedPage) ? _c('div', {
    staticClass: "form__sub-section"
  }, [_c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.province),
      expression: "province"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.province = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectProvince]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- จังหวัด -")]), _vm._v(" "), _vm._l((_vm.provinces), function(province) {
    return _c('option', {
      domProps: {
        "value": province.id
      }
    }, [_vm._v(_vm._s(province.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['province'].empty),
      expression: "$v.$errors['province'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกจังหวัด")])]) : _vm._e(), _vm._v(" "), (_vm.type == 2 && _vm.selectedPage) ? _c('div', {
    staticClass: "form__sub-section"
  }, [_c('div', {
    staticClass: "result-selected shadow"
  }, [_c('page-preview', {
    attrs: {
      "page": _vm.selectedPage
    },
    on: {
      "clear": _vm.clear
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form__section"
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('label', {
    staticClass: "form__label form__label--title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "1")
    },
    on: {
      "change": function($event) {
        _vm.type = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon _sl-phapa"
  }, [_vm._v(" ")]), _vm._v("เลือกกองผ้าป่าที่คุณต้องการบริจาค\n        ")]), _vm._v(" "), (_vm.type == 1 && !_vm.selectedPage) ? _c('div', {
    staticClass: "form__sub-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "searchInput",
    staticClass: "form__text_lg txt-search",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": _vm.searchKeyUp,
      "focus": _vm.searchKeyUp,
      "blur": function($event) {
        return _vm.searchUnfocus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.pageResults.length > 0) ? _c('ul', {
    staticClass: "result-list"
  }, _vm._l((_vm.pageResults), function(page) {
    return _c('li', {
      staticClass: "result-item"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectPage(page)
        }
      }
    }, [_vm._v(_vm._s(page.title))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors['selectedPage'].empty),
      expression: "$v.$errors['selectedPage'].empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกกองผ้าป่า")])]) : _vm._e(), _vm._v(" "), (_vm.type == 1 && _vm.selectedPage) ? _c('div', {
    staticClass: "form__sub-section result-selected shadow"
  }, [_c('page-preview', {
    attrs: {
      "page": _vm.selectedPage
    },
    on: {
      "clear": _vm.clearSelectPage
    }
  })], 1) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-remark"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("หรือเลือกประเภทบริจาค")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-042514d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-042514d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageSelector.vue
// module id = 717
// module chunks = 1